import { render } from "./CouponFreeKanom.vue?vue&type=template&id=7086ce4c&scoped=true"
import script from "./CouponFreeKanom.vue?vue&type=script&lang=js"
export * from "./CouponFreeKanom.vue?vue&type=script&lang=js"

import "./CouponFreeKanom.vue?vue&type=style&index=0&id=7086ce4c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7086ce4c"

export default script